var $ = require( 'jquery' );

$( document ).ready( function() {
    initTabs();
});

function initTabs() {
    $('.programs__tab-triggers__item').off('click').on('click', function(e) {
        e.preventDefault();
        const index = $(this).attr('data-tab-index');
        const sectionName = $(this).data('active-item');
        
        const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('filter', sectionName);
		window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);

        $('.programs__tabs__item').removeClass('active');
        $('.programs__tab-triggers__item').removeClass('active');
        $('.programs__tabs__item[data-tab-index="' + index + '"]').addClass('active');
        $(this).addClass('active');

        if($(this).data('active-item').length > 0) {
            $('.section-arros-download__logo').removeClass('active');
            $('.section-arros-download__content--inner').removeClass('active');
            $('.section-arros-download__bg').removeClass('active');
            $('.section-arros-download__logo[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__content--inner[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__bg[data-name="' + sectionName + '"]').addClass('active');
        }
    });
    $('.programs__tab-select').on('change', function(){
        const index = $(this).val();
        const sectionName = $('option:selected', this).attr('data-active-item');
        $('.programs__tabs__item').removeClass('active');
        $('.programs__tab-triggers__item').removeClass('active');
        $('.programs__tabs__item[data-tab-index="' + index + '"]').addClass('active');

        if(sectionName.length > 0) {
            $('.section-arros-download__logo').removeClass('active');
            $('.section-arros-download__content--inner').removeClass('active');
            $('.section-arros-download__bg').removeClass('active');
            $('.section-arros-download__logo[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__content--inner[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__bg[data-name="' + sectionName + '"]').addClass('active');
        }
    });
    if(window.innerWidth < 992){
        $('.ui-selectmenu-menu').on('click', function() {
            $('.programs__tab-select').change();
        })
    }

    // initially activate tab based on url filter query
    const urlParams = new URLSearchParams(window.location.search);
    const currTabFilter = urlParams.get('filter');
    const tabBtns = $('#programs .programs__tab-triggers__item');
    tabBtns.each((index, item)=>{
        const dataAttribute = $(item).data('active-item');
        if(dataAttribute=== currTabFilter){
            // scroll to programs section
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#programs").offset().top
            }, 1000);

            $(`#programs [data-active-item]`).removeClass('active');
            $(`#programs [data-active-item="${dataAttribute}"]`).addClass('active');
        }
    })
    
}
